export default {
    vi: {
        "home.title": "Đặt lịch tiêm & phòng ngừa<br class='hidden sm:block'> cho thú cưng ngay hôm nay!",
        "home.subtitle": "Thật đơn giản & tiện lợi!",
        "home.subtitle.copy": "Chỉ cần điền vài thông tin bên dưới,<br class='hidden sm:block'> lịch nhắc tự động sẽ được gửi cho bạn.",
        "home.mandatory": "Các trường có dấu * là bắt buộc",
        "home.calendars": "Tương thích với hầu hết các lịch nhắc hẹn trên ứng dụng:",
        "home.calendar.google": "Lịch <br class='sm:hidden'> Google",
        "home.calendar.outlook":
            "Lịch ứng dụng Outlook <br class='sm:hidden'> trên máy tính",
        "home.calendar.outlook.web":
            "Outlook Web <br class='sm:hidden'> Calendar",
        "home.calendar.other": "Other <br class='sm:hidden'> Calendar",
        "home.calendar.ios": "Lịch <br class='sm:hidden'> iOS",
        "home.calendar.google.striphtml": "Lịch Google",
        "home.calendar.outlook.striphtml": "Lịch ứng dụng Outlook trên máy tính",
        "home.calendar.outlook.web.striphtml": "Outlook Web Calendar",
        "home.calendar.other.striphtml": "Other Calendar",
        "home.calendar.ios.striphtml": "Lịch iOS",
        "home.error.noReminderValues": "Lịch nhắc chưa đủ thông tin để tạo",
        "form.petName": "Tên thú cưng của bạn là<sup>(*)</sup>",
        "form.product": "Chó/ Mèo của bạn đang sử dụng sản phẩm<sup>(*)</sup>",
        "form.species": "Thú cưng của bạn là<sup>(*)</sup>",
        "form.species.dog": "Chó",
        "form.species.cat": "Mèo",
        "form.please.select": "Vui lòng chọn",
        "form.format": "Format*",
        "form.capsuleStrength": "Capsule strength*",
        "form.bottleSize": "Add a bottle",
        "form.dosage": "Dosage*",
        "form.age": "Tuổi:*",
        "form.ageYears": "Số năm tuổi*",
        "form.ageMonths": "Số tháng tuổi*",
        "form.ageWeeks": "Số tuần tuổi*",
        "form.vaccinationDate": "Ngày nhắc tiêm phòng:",
        "form.vaccinationDateNumber": "Chọn ngày",
        "form.dog.weight": "Cân nặng của Chó*",
        "form.cat.weight": "Cân nặng của Mèo*",
        "form.applicators": "Number of applicators*",
        "form.senvelgoCatWeight": "Cân nặng của Mèo*",
        "form.senvelgoCatWeightPlaceholder": "Weight in kg",
        "form.dosage.placeholder": "Weight in Kg",
        "form.dosage.placeholder.chews": "Dosage based on the prescription",
        "form.reminderStartDate": "Ngày bắt đầu lịch nhắc*",
        "form.reminderStartDate.placeholder": "Chọn ngày",
        "form.reminderStartTime": "Giờ bắt đầu lịch nhắc*",
        "form.reminderStartTime.placeholder": "Chọn giờ",
        "form.reminderStartDate1.placeholder": "Mũi tiêm 1",
        "form.reminderStartDate2.placeholder": "Mũi tiêm 2",
        "form.reminderStartDate3.placeholder": "Mũi tiêm 3",
        "form.reminderStartDate4.placeholder": "Mũi tiêm 4",
        "form.reminderStartTime.button": "Áp dụng",
        "form.numberOfChews": "Number of chews prescribed",
        "form.specialComments":
            "Bạn có muốn thêm ghi chú đặc biệt nào vào lời nhắc lịch không?",
        "form.chews": "Number of chews*",
        "form.generate": "Tạo lịch nhắc",
        "form.no.options": "No options available",
        "form.frequency": "Frequency*",
        "form.error.1": "à Có",
        "form.error.1.single": "à Có",
        "form.error.2": "à Đăng ký lịch nhắc không thành công",
        "form.error.2.single": "à Đăng ký lịch nhắc không thành công",
        "generating": "Đang tạo lịch nhắc của bạn...",
        "download.headline": "Lưu lại lịch nhắc trên ứng dụng yêu thích của bạn",
        "download.easy": "Thật đơn giản!",
        "accordion.title.1":
            "Bạn có muốn lưu những thông tin này trên thiết bị khác không?",
        "accordion.title.2": "Không thể lưu lịch nhắc?",
        "accordion.enter.visit":
            "Hãy truy cập vào phần hỗ trợ trên trang web bằng cách nhấn vào biểu tượng bên dưới:",
        "accordion.enter.email":
            "Hãy điền email ở đây và đường dẫn sẽ được gửi đến bạn ngay.",
        "accordion.email.send":
            "à Lịch nhắc đã được gửi đến địa chỉ email của bạn.",
        "accordion.terms":
            "Bằng việc nhấn đăng ký bên dưới, tôi đồng thuận để Cty TNHH Thuốc thú y Boehringer Ingelheim gửi Lời nhắc sử dụng thuốc qua email của tôi. Tham khảo thêm thông tin tại <a href='{privacy}'>Chính sách bảo mật</a> và <a href='{link}'>Điều khoản sử dụng</a>.",
        "button.generate": "Tạo lịch nhắc khác",
        "button.submit": "Đăng ký",
        "button.generate.another": "Tạo lịch nhắc khác",
        "how.often": "Tần suất bạn muốn nhận nhắc nhở.*",
        "select.timezone": "Múi giờ của bạn",
        "metacam.first.bottle":
            "Is this the first bottle of Metacam® prescribed for the given dog?",
        "option.yes": "Yes",
        "option.no": "No",
        "option.chews": "Chews",
        "option.everyday": "Everyday",
        "option.everyday.first.week": "Everyday for the first week",
        "option.refill.reminder": "Just the refill reminder",
        "download.your": "Lịch nhắc sử dụng",
        "download.start": "hàng tháng sẽ được bắt đầu từ:",
        "download.bottleOf": "à Chai của",
        "download.willLast": "à sẽ kéo dài",
        "download.days": "à ngày",
        "email.vaccination": "<strong>{name}’s</strong> à tiếp theo <strong>{product}{trademark}</strong> đợt tiêm vắc-xin tiếp theo vào ngày <strong>{date}</strong>. à Hãy đưa thú cưng đến BSTY thăm khám định kỳ để bé cưng luôn vui khỏe!"
    },
};
